 <template>
  <div class="ChallengesTopics">
      <topics-search-bar></topics-search-bar>  
      <topics-details v-bind:topicList="getTopicList" @refreshTopicList="refreshTopicList"></topics-details>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
  </div>
</template>
<script>
import { constants } from '@/utils/constants'
import { topicService } from '@/server-util/topic-service'
import AlertBox from '@/components/AlertOverlay'
import TopicsSearchBar from '@/components/ChallengesTopicsSearchBar'
import TopicDetails from '@/components/TopicDetailsList'
import Loader from '@/components/dashboard/Loader'
export default {
  created: function () {
    this.getTopics()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false
    }
  },
  methods: {
    refreshTopicList (value) {
      // AK: Reload List after successfully Delete and Edit operation
      if (value) {
        this.getTopics()
      }
    },
    getTopics: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== '' ||
        storeObj.state.access_token !== null
      ) {
        if (storeObj.state.topicList.length === 0) {
          // AK: Start showing spinner only if topic list not found
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }

        topicService.getAllTopics(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.topicList = responseObj.data
              // AK: Hide Spinner if its showing to user
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              // console.log(JSON.stringify(storeObj.state.topicList))
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner if its showing to user
            // _this.showSpinner = false
            this.$store.state.isLoading = false
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET TOPIC LIST OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {
    getTopicList: {
      get: function () {
        return this.$store.state.topicList
      }
    }
  },
  components: {
    'topics-search-bar': TopicsSearchBar,
    'topics-details': TopicDetails,
    'alert-box': AlertBox,
    'loader': Loader
  },
  name: 'ChallengesTopics'
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.ManageCourseDetailList{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .margin-Top-1Perc
{
	margin-top: 1%;
}
.tdMargin-Top-1Perc
{
	margin-top: 1%;
}
 .margin-left-2Point7Perc
{
	margin-left: 2.7%;
}
 .margin-right-1Point1Perc
{
	margin-right: 1.1%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.text-align-center {
 text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.imgWidthHeight{
  width:180px; 
  height:110px;
}
.padding-Top-1Perc{
  padding-Top:1%;
}
.padding-top-2Perc {
  padding-top: 2% !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.btn-text-color{
  color:#2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/ChallengesTopics.vue